/* eslint-disable quotes */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BlogTags } from '../../_shared/_enums/blog-tags';
import { IShopifyProduct, SEO } from '@app/_shared/_models';
import { BlogService } from '../../_shared/_services/blog.service';
import { ProductService } from '../../_shared/_services/product.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-sironas-simply-three-step-water-program',
    templateUrl: './sironas-simply-three-step-water-program.component.html',
    styleUrls: ['./sironas-simply-three-step-water-program.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class SironasSimplyThreeStepWaterProgramComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/logos/sirona_logo.png',
    metaDescription: `Learn about one of the best chlorine and bromine free solutions to keep your hot tub or spa clean.`,
    metaTitle: `Sirona Simply's 3 Step Water Care Program`
  };
  public spinner$: Observable<NgxSpinner>;
  public simplyWaterLine: IShopifyProduct | undefined;
  public simplyOxidizer: IShopifyProduct | undefined;
  public simplySanitizer: IShopifyProduct | undefined;
  public simplyTestStrips: IShopifyProduct | undefined;
  public simplyMetalControl: IShopifyProduct | undefined;
  public blogPost!: IBlogPost;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/sironas-simply-three-step-water-program');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.SIMPLY_3_STEP);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.simplyWaterLine = await this.productService.loadProductByHandle('sirona-spa-care-simply-waterline-control');
    this.simplyOxidizer = await this.productService.loadProductByHandle('sirona-spa-care-simply-oxidizer');
    this.simplySanitizer = await this.productService.loadProductByHandle('sirona-spa-care-simply-sanitizer');
    this.simplyTestStrips = await this.productService.loadProductByHandle('sirona-spa-care-simply-test-strips');
    this.simplyMetalControl = await this.productService.loadProductByHandle('sirona-spa-care-simply-metal-control');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
